import { Component, inject, OnInit, ChangeDetectorRef } from '@angular/core';

import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { forkJoin } from 'rxjs';

import { PedidosService, Pedido } from '../../../core/services/pedidos.service';

import { ParceirosService } from '../../../core/services/parceiros.service';

@Component({
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.css',
})
export class AdminDashboard implements OnInit {
  private pedidosApi = inject(PedidosService);
  private parceirosApi = inject(ParceirosService);
  private cdr = inject(ChangeDetectorRef);

  pedidos: Pedido[] = [];
  totalParceiros = 0;
  erro = '';
  carregando = true;

  get pagos(): Pedido[] {
    return this.pedidos.filter((p) => p.statusPagamento === 'PAGO');
  }

  get receita(): number {
    return this.pagos.reduce((total, pedido) => total + (Number(pedido.valorTotal) || 0), 0);
  }

  ngOnInit(): void {
    this.carregarDashboard();
  }

  carregarDashboard(): void {
    this.carregando = true;
    this.erro = '';

    this.cdr.detectChanges();

    forkJoin({
      pedidos: this.pedidosApi.listar(),
      parceiros: this.parceirosApi.listar(),
    }).subscribe({
      next: (resultado) => {
        this.pedidos = resultado.pedidos;
        this.totalParceiros = resultado.parceiros.length;
        this.carregando = false;

        this.cdr.detectChanges();
      },

      error: (error) => {
        console.error('Erro ao carregar dashboard:', error);

        this.erro = 'Não foi possível carregar o dashboard.';

        this.carregando = false;

        this.cdr.detectChanges();
      },
    });
  }
}
